import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

// Reuses the same screen the Google flow uses. The screen reads
// `location.pathname` to decide which hub to return to on Cancel/Confirm.
const ImportCatalogPage = lazy(() => import('~/features/onboarding/pages/import-catalog-screen'));

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/meta/import-catalog',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ImportCatalogPage />
    </Suspense>
  ),
});
